export const COMMODITIES = {
  TRACK: 1,
  PAY: 2,
  RESOLVE: 3,
  PERFORM: 4,
  STORE: 5,
  RECRUIT: 6,
  HRIS: 13,
  ASSET: 17,
};
